import React from 'react';
import { Tabs } from 'antd';
import TagsSettings from './settings/TagsSettings';
import RatingsSettings from './settings/RatingsSettings';
import SourcesSettings from './settings/SourcesSettings';
import PublicSeaSettings from './settings/PublicSeaSettings';
import DepartmentsSettings from './settings/DepartmentsSettings';
import PositionsSettings from './settings/PositionsSettings';
import OnboardingTasksSettings from './settings/OnboardingTasksSettings';
import EmployeeTaskTemplatesSettings from './settings/EmployeeTaskTemplatesSettings';

const Settings = () => {
  const items = [
    {
      key: 'departments',
      label: '部门管理',
      children: <DepartmentsSettings />
    },
    {
      key: 'positions',
      label: '岗位管理',
      children: <PositionsSettings />
    },
    {
      key: 'onboarding-tasks',
      label: '入职任务管理',
      children: <OnboardingTasksSettings />
    },
    {
      key: 'employee-task-templates',
      label: '员工任务模板',
      children: <EmployeeTaskTemplatesSettings />
    },
    {
      key: 'tags',
      label: '标签管理',
      children: <TagsSettings />
    },
    {
      key: 'ratings',
      label: '评级管理',
      children: <RatingsSettings />
    },
    {
      key: 'sources',
      label: '来源管理',
      children: <SourcesSettings />
    },
    {
      key: 'public-sea',
      label: '公海管理',
      children: <PublicSeaSettings />
    }
  ];

  return (
    <div style={{ padding: '10px 16px' }}>
      <Tabs items={items} />
    </div>
  );
};

export default Settings; 